import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from '../PopupBox.js';



export default class AssistantBox extends React.Component {


    scrollToBottom = () => {
        if(this.messagesEnd)
        {
            this.messagesEnd.scrollIntoView({ behavior: "smooth" });
        }

        var spaces = document.getElementsByClassName("assistant_message_space")

        for(var i = 0; i < spaces.length; i ++)
        {
            spaces[i].scrollTop = spaces[i].scrollHeight;
        }
        
      }
      
      componentDidMount() {
        this.scrollToBottom();

        
      }
      
      componentDidUpdate() {
        this.scrollToBottom();
      }

    constructor(props){
        super(props);
        this.state = {
            messages: [{text:"Hello, I will answer all your questions honestly.", from:"assistant"}],
            thinking: false,
            thinking_dots: 0,
            showing: true
        }
      }




     

  render() {


   


    //handle the click on one of the buttons
    const toggleAssistant = (e) => {

        this.setState({
            showing: !this.state.showing
        })
        
    }


    //handle the click on one of the buttons
    const handleClick = (e) => {

        
        var question = e.target.getAttribute("question")
        var answer = e.target.getAttribute("answer")

        var delay = answer.length * 50 + 500 + Math.random()*400

        this.setState({
              messages: this.state.messages.concat({text:question, from:"player"}),
              thinking: true
          })


        clearInterval(this.interval)
        this.interval = setInterval(function(that){

            var new_dots = that.state.thinking_dots + 1

            if(new_dots > 3)
            {
                new_dots = 0
            }
            that.setState(
                {
                    thinking_dots: new_dots
                })

            


        },400, this)

        setTimeout(function(object) {

            clearInterval(object.that.interval)

            object.that.setState(
                {
                    messages: object.that.state.messages.concat(object.message),
                    thinking: false
                })


        }, delay, {that:this, message: {text:answer, from:"assistant"}})
      


      






    };

    var questions = this.props.questions

    var question_buttons = []

    for(var i = 0; i < questions.length; i ++)
    {
        question_buttons.push(
            
            <tr><Button value="0" onClick={handleClick} className="m-1 btn-sm p-2" question={questions[i][0]} answer={questions[i][1]}  variant="light">{questions[i][0]}</Button></tr>

        )
    }


    var messages = this.state.messages


    var message_divs = []

    for(var i = 0; i < messages.length; i ++)
    {
        message_divs.push(<div class={"assistant_message from_" + messages[i].from}>{messages[i].text}</div>)
    }


    var dots = ""

    for(var i = 0; i < this.state.thinking_dots; i ++)
    {
        dots += ".";
    }

    if(this.state.thinking == true)
    {
        message_divs.push(<div class={"assistant_message from_assistant thinking"}>{dots}</div>)
    }

    /*
    message_divs.push(

        <div style={{ float:"left", }}
             ref={(el) => { this.messagesEnd = el; }}>
        </div>
    

    )
    */

    if(this.state.showing == false)
    {
        return (




            <div class={"assistant " + this.props.side}>
    
                <div style={{textAlign: "center"}} class="close_assistant" onClick={toggleAssistant}>
    
                Ask Assistant {this.props.number}
    
                </div>
            </div>
            )
    }

    else
    {

     
        return (




        <div class={"assistant " + this.props.side}>

            <div class="close_assistant" onClick={toggleAssistant}>

            Assistant {this.props.number}

            <div class="x" onClick={toggleAssistant}>x</div>

            </div>


            <div class="assistant_message_space">

            {message_divs}

            </div>


            <div className="d-flex justify-content-center">
                <ButtonToolbar>

                        {question_buttons}

                </ButtonToolbar>

            </div>


        </div>

        );

    }
    
  }
}
